<template>
    <div class="station-vehicles-management">
        <div class="page-header">
            <h2>{{ $t('stationVehicles.pageTitle') }}</h2>
        </div>

        <div class="content-wrapper">
            <!-- 左侧站点列表 -->
            <div class="station-section">
                <el-card class="station-card">
                    <div slot="header" class="station-card-header">
                        <h3>{{ $t('stationVehicles.stationList') }}</h3>
                    </div>
                    <el-table :data="stationList" style="width: 100%" @row-click="selectStation"
                        :row-class-name="tableRowClassName" highlight-current-row border>
                        <el-table-column prop="name" :label="$t('stationVehicles.stationName')"
                            min-width="120"></el-table-column>
                        <el-table-column prop="description" :label="$t('stationVehicles.description')"
                            show-overflow-tooltip min-width="180"></el-table-column>
                    </el-table>
                </el-card>
            </div>

            <!-- 右侧车辆绑定区域 -->
            <div class="vehicle-section">
                <el-card class="vehicle-card">
                    <div slot="header" class="vehicle-card-header">
                        <h3>{{ $t('stationVehicles.bindVehicle') }}</h3>
                        <span v-if="selectedStation" class="selected-station-name">
                            {{ $t('stationVehicles.currentStation') }}: {{ selectedStation.name }}
                        </span>
                    </div>

                    <div v-if="selectedStation" class="bind-content">
                        <!-- 车辆选择区域 -->
                        <div class="vehicle-select-section">
                            <h4>{{ $t('stationVehicles.selectVehicles') }}</h4>
                            <el-select v-model="selectedVehicleIds" multiple filterable :placeholder="$t('stationVehicles.pleaseSelectVehicle')"
                                style="width: 100%;" size="medium">
                                <el-option v-for="vehicle in availableVehicles" :key="vehicle.vehicleId"
                                    :label="vehicle.vehicleName" :value="vehicle.vehicleId">
                                </el-option>
                            </el-select>
                            <el-button type="primary" size="medium" @click="bindVehicles" :loading="binding"
                                style="margin-top: 16px;">
                                {{ $t('stationVehicles.bindBtn') }}
                            </el-button>
                        </div>

                        <!-- 已绑定车辆列表 -->
                        <div class="bound-vehicles-section">
                            <h4>{{ $t('stationVehicles.boundVehicles') }}</h4>
                            <el-table :data="boundVehicles" style="width: 100%" border size="medium">
                                <el-table-column type="index" :label="$t('public.index')" width="60" align="center">
                                </el-table-column>
                                <el-table-column prop="vehicleName" :label="$t('stationVehicles.vehicleName')"
                                    min-width="150"></el-table-column>
                                <el-table-column prop="vehicleNo" :label="$t('stationVehicles.vehicleNo')"
                                    min-width="120"></el-table-column>
                                <el-table-column :label="$t('public.Operation')" width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-button size="mini" type="danger" @click="unbindVehicle(scope.row)">
                                            {{ $t('stationVehicles.unbindBtn') }}
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-if="boundVehicles.length === 0" class="empty-tip">
                                {{ $t('stationVehicles.noBoundVehicles') }}
                            </div>
                        </div>
                    </div>

                    <div v-else class="empty-tip">
                        {{ $t('stationVehicles.pleaseSelectStation') }}
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'StationVehiclesManagement',
    data() {
        return {
            stationList: [],
            vehicleList: [],
            selectedStation: null,
            selectedVehicleIds: [],
            boundVehicles: [],
            binding: false,
            selectedStationId: null,
            stationVehicleBindings: []
        };
    },
    computed: {
        ...mapState({
            language: state => state.user.language,
            vehicles: state => state.app.vehicles
        }),
        availableVehicles() {
            const boundVehicleIds = this.boundVehicles.map(v => v.vehicleId);
            return this.vehicleList.filter(v => !boundVehicleIds.includes(v.vehicleId));
        }
    },
    mounted() {
        this.initMockData();
    },
    methods: {
        initMockData() {
            this.stationList = [
                {
                    id: 1,
                    name: '站点A',
                    longitude: '115.52873841196535',
                    latitude: '40.141636379850915',
                    description: '这是一个模拟的站点A，位于北京市中心'
                },
                {
                    id: 2,
                    name: '站点B',
                    longitude: '116.404089',
                    latitude: '39.915824',
                    description: '这是一个模拟的站点B，位于北京东城区'
                },
                {
                    id: 3,
                    name: '站点C',
                    longitude: '116.380529',
                    latitude: '39.916323',
                    description: '这是一个模拟的站点C，位于北京西城区'
                }
            ];

            this.vehicleList = [
                { vehicleId: 'V001', vehicleName: '车辆001', vehicleNo: '京A12345' },
                { vehicleId: 'V002', vehicleName: '车辆002', vehicleNo: '京B12345' },
                { vehicleId: 'V003', vehicleName: '车辆003', vehicleNo: '京C12345' },
                { vehicleId: 'V004', vehicleName: '车辆004', vehicleNo: '京D12345' },
                { vehicleId: 'V005', vehicleName: '车辆005', vehicleNo: '京E12345' },
                { vehicleId: 'V006', vehicleName: '车辆006', vehicleNo: '京F12345' }
            ];

            this.stationVehicleBindings = [
                { stationId: 1, vehicleId: 'V001' },
                { stationId: 1, vehicleId: 'V003' },
                { stationId: 2, vehicleId: 'V002' }
            ];
        },

        selectStation(station) {
            this.selectedStation = station;
            this.selectedStationId = station.id;
            this.selectedVehicleIds = [];
            this.loadBoundVehicles();
        },

        loadBoundVehicles() {
            if (!this.selectedStation) {
                this.boundVehicles = [];
                return;
            }
            const boundVehicleIds = this.stationVehicleBindings
                .filter(binding => binding.stationId === this.selectedStation.id)
                .map(binding => binding.vehicleId);
            this.boundVehicles = this.vehicleList.filter(v => boundVehicleIds.includes(v.vehicleId));
        },

        bindVehicles() {
            if (!this.selectedStation) {
                this.$message.warning(this.$t('stationVehicles.pleaseSelectStation'));
                return;
            }
            if (this.selectedVehicleIds.length === 0) {
                this.$message.warning(this.$t('stationVehicles.pleaseSelectVehicle'));
                return;
            }

            this.binding = true;
            setTimeout(() => {
                this.selectedVehicleIds.forEach(vehicleId => {
                    const exists = this.stationVehicleBindings.find(
                        b => b.stationId === this.selectedStation.id && b.vehicleId === vehicleId
                    );
                    if (!exists) {
                        this.stationVehicleBindings.push({
                            stationId: this.selectedStation.id,
                            vehicleId: vehicleId
                        });
                    }
                });
                this.loadBoundVehicles();
                this.selectedVehicleIds = [];
                this.binding = false;
                this.$message.success(this.$t('stationVehicles.bindSuccess'));
            }, 500);
        },

        unbindVehicle(vehicle) {
            this.$confirm(
                this.$t('stationVehicles.unbindConfirm', { vehicleName: vehicle.vehicleName }),
                this.$t('public.tips'),
                {
                    confirmButtonText: this.$t('public.confirm'),
                    cancelButtonText: this.$t('public.cancel'),
                    type: 'warning'
                }
            ).then(() => {
                this.stationVehicleBindings = this.stationVehicleBindings.filter(
                    b => !(b.stationId === this.selectedStation.id && b.vehicleId === vehicle.vehicleId)
                );
                this.loadBoundVehicles();
                this.$message.success(this.$t('stationVehicles.unbindSuccess'));
            }).catch(() => {});
        },

        tableRowClassName({ row }) {
            return row.id === this.selectedStationId ? 'selected-row' : '';
        }
    }
};
</script>

<style scoped>
.station-vehicles-management {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
}

.page-header {
    margin-bottom: 20px;
}

.content-wrapper {
    display: flex;
    gap: 20px;
    height: calc(100% - 80px);
}

.station-section {
    width: 40%;
    display: flex;
    flex-direction: column;
}

.vehicle-section {
    width: 60%;
    display: flex;
    flex-direction: column;
}

.station-card,
.vehicle-card {
    height: 100%;
    overflow: auto;
}

.station-card-header,
.vehicle-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.selected-station-name {
    color: #409EFF;
    font-size: 14px;
}

.bind-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.vehicle-select-section {
    padding: 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.vehicle-select-section h4 {
    margin-top: 0;
    margin-bottom: 12px;
    color: #303133;
}

.bound-vehicles-section h4 {
    margin-top: 0;
    margin-bottom: 12px;
    color: #303133;
}

.empty-tip {
    text-align: center;
    color: #909399;
    padding: 40px 0;
    font-size: 14px;
}

::v-deep .selected-row {
    background-color: #ecf5ff;
}

::v-deep .el-table__row {
    cursor: pointer;
}
</style>
